export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PersonalData.vue?vue&type=template&id=5e1ba309&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/PersonalData.vue?vue&type=template&id=5e1ba309&scoped=true&
// module id = 621
// module chunks = 3